import { BoardFloorCreatableInterface } from '../interfaces/board-floor-creatable.interface';
import { BoardFloorDto } from './board-floor.dto';
import { PickType } from '@nestjs/swagger';

export class BoardFloorCreateDto
  extends PickType(BoardFloorDto, [
    'floor',
    'quantity',
    'boardTypeId',
    'boardPurchaseId',
  ])
  implements BoardFloorCreatableInterface {}
